import config from './config';

let getUrl = () => {
    return process.env.NODE_ENV === 'development' ? config.default : (config[process.env.srconfig] || config.default);
}
let url = getUrl(); //登录
let UpImgUri = url + `/image/upload`; //图片上传地址
let UpFileUri = url + `/file/upload`; //附件上传地址
let projectUrl = config.project; //
export {
    url,
    UpImgUri,
    UpFileUri,
    projectUrl
}
